export default {
	GET_ALL: (crewId) => `/houseItem/all?crewId=${crewId}`,
	CREATE: (crewId) => `/houseItem?crewId=${crewId}`,
	UPDATE: () => "/houseItem",
	UPDATE_BUY: (id) => `/houseItem/${id}/buy`,
	DELETE: (id) => `/houseItem/${id}`,
	GET_NEXT: (crewId) => `/houseItem/next?crewId=${crewId}`,
};
